define.alias("ember-math-helpers/helpers/add", "settings/helpers/add");